var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgExclaimation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10 20C15.5228 20 20 15.5228 20 10C20 4.47715 15.5228 0 10 0C4.47715 0 0 4.47715 0 10C0 15.5228 4.47715 20 10 20Z",
    fill: "#EE741F"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.1497 13.1382C10.5775 13.1382 10.9243 13.485 10.9243 13.9128C10.9243 14.3407 10.5775 14.6875 10.1497 14.6875C9.72183 14.6875 9.375 14.3407 9.375 13.9128C9.375 13.485 9.72183 13.1382 10.1497 13.1382ZM10.1497 5.3125C10.4843 5.3125 10.7594 5.54934 10.7906 5.85217L10.7935 5.90968V11.1532C10.7935 11.483 10.5052 11.7504 10.1497 11.7504C9.81499 11.7504 9.53996 11.5135 9.50876 11.2107L9.50581 11.1532V5.90968C9.50581 5.57987 9.79407 5.3125 10.1497 5.3125Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExclaimation);
export default __webpack_public_path__ + "static/media/exclaimation.089fb06d6b2dd078d169a166ccd96f3e.svg";
export { ForwardRef as ReactComponent };